import { render, staticRenderFns } from "./CreateUserPage.vue?vue&type=template&id=0dc50657&scoped=true&"
import script from "./CreateUserPage.vue?vue&type=script&lang=js&"
export * from "./CreateUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc50657",
  null
  
)

export default component.exports